export default function formatPhoneNumber(originalString: string) {
  let plain = originalString.replace(/[^a-zA-Z0-9]/g, "");

  if (plain.length===11 && plain[0]==="1")
    plain = plain.substring(1);  // Remove initial char (1)
  else if (plain.length!==10)
    return originalString;  // Non-standard - return original

  return `${plain.substring(0, 3)}-${plain.substring(3,6)}-${plain.substring(6, 10)}`;
}
